import React, { useState } from "react";
import Container from "../../components/Container/Container";
import BackButton from "../../components/BackButton/BackButton";
import Questionnaire from "../../components/Questionnaire/Questionnaire";
import { useAppContext } from "../../context/AppContext";
import ReactMarkdown from "react-markdown";
import { QuestionnaireDefinition } from "../../types/content";
import { CollectedAnswer, OnAnswersCollected } from "../../types/training";
import { useSectionCompletion } from "../../hooks/useSectionCompletion";
import "./questionnairePage.scss";

interface QuestionnairePageProps extends QuestionnaireDefinition {
  onAnswersCollected: OnAnswersCollected;
}

const QuestionnairePage: React.FC<QuestionnairePageProps> = ({
  title,
  description,
  questions,
  onAnswersCollected,
}) => {
  const [collectedAnswers, setCollectedAnswers] = useState<CollectedAnswer[]>([]);
  const [correctAnswersCount, setCorrectAnswersCount] = useState<number | null>(null);
  const [totalAnswersCount, setTotalAnswersCount] = useState<number>(0);

  const { selectedProduct, isEnglish } = useAppContext();
  const isCompleted = useSectionCompletion(selectedProduct);

  const handleAnswersCollected: OnAnswersCollected = (answers) => {
    setCollectedAnswers((prevAnswers) => [...prevAnswers, ...answers]);
    onAnswersCollected([...collectedAnswers, ...answers]); // Pass all collected answers
  };

  return (
    <Container>
      <div className="questionnaire-page">
        <BackButton />
        {correctAnswersCount !== null ? (
          <div className="questionnaire-page__correct-answers">
            <img
              className="questinnaire-page__correct-answers-icon"
              src="/assets/clapping.svg"
              alt="clapping hands"
              width={64}
            />
            {isEnglish ? "Congratulations on completing the test!" : "Sveikiname atlikus testą!"}
            <span className="questionnaire-page__correct-answers-count">
              {isEnglish ? (
                <>
                  Your score is{" "}
                  <strong>
                    {correctAnswersCount} out of {totalAnswersCount}
                  </strong>{" "}
                  correct answers.
                </>
              ) : (
                <>
                  Jūsų rezultatas yra{" "}
                  <strong>
                    {correctAnswersCount} iš {totalAnswersCount}
                  </strong>{" "}
                  teisingų atsakymų.
                </>
              )}
            </span>
          </div>
        ) : (
          <>
            <h2 className="questionnaire-page__heading">{title}</h2>
            {description ? (
              <p className="questionnaire-page__description">
                <ReactMarkdown>{description}</ReactMarkdown>
              </p>
            ) : (
              ""
            )}
          </>
        )}
        <Questionnaire
          questions={questions}
          onAnswersCollected={handleAnswersCollected}
          setCorrectAnswersCount={setCorrectAnswersCount}
          correctAnswersCount={correctAnswersCount}
          isDisabled={isCompleted}
          isPracticeQuestion={description !== undefined}
          setTotalAnswersCount={setTotalAnswersCount}
        />
      </div>
    </Container>
  );
};

export default QuestionnairePage;
